import WrapperLayout from 'components/Layout';
import Main from "./Components/Main"
const SequenceManager = () =>{
    return(
        <>
        <WrapperLayout>
            <Main/>
        </WrapperLayout>
    </>
    )
}
export default SequenceManager